import { ErrorHandler, Injectable, NgZone } from '@angular/core'
import { HttpErrorResponse, HttpResponse } from "@angular/common/http"
import { ERRORCODES } from './error-codes'
import { CONSTANTS } from './constants'
import { LoggingService } from './LoggingService'
import { HelperService } from '../helper/services/helper.service'
import { SharedDataService } from '../helper/services/shared-data.service'

import { API } from '../data/api'
import { environment } from '../../environments/environment'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private loggingService: LoggingService,
    private helper: HelperService,
    private sharedDataService: SharedDataService,
  ) { }

  handleError(error: Error | HttpErrorResponse | HttpResponse<any>) {
    let message: string
    let stack: string

    // Backend Response Codes
    if (error instanceof HttpResponse) {
      message = error.body
      stack = error.url || ''

      switch (error.body) {
        case ERRORCODES.RESPONSE_FAILED_LOGIN.error_code:
          this.helper.openSnackBar(CONSTANTS.loginError, 0)
          break
        case ERRORCODES.RESPONSE_DATABASE_ERROR.error_code:
          break
        case ERRORCODES.RESPONSE_MALFORMED_PAYLOAD.error_code:
          break
        case ERRORCODES.RESPONSE_RESOURCE_READ_ONLY:
          break
        case ERRORCODES.RESPONSE_PAYLOAD_SIZE_EXCEEDED.error_code:
          break
        case ERRORCODES.RESPONSE_NOT_EMPTY.error_code:
          break
        default:
          break
      }
    }

    // Http Error Codes
    else if (error instanceof HttpErrorResponse) {
      message = error.message
      stack = error.url || ''
      this.sharedDataService.toggleProgressBarOff()

      if (error instanceof HttpErrorResponse && error.status > 0)
        switch (error.status) {
          case 0:
            this.helper.openSnackBar(CONSTANTS.unknownError, 0)
            break
          case 401:
          case 403:
            switch (error.url?.substring(environment.url.length, error.url.indexOf('?version'))) {
              case API.courseManagerChangePassword:
                this.helper.openSnackBar(CONSTANTS.passwordAuthFailedMessage, 0)
                break
              default:
                this.helper.openSnackBar(CONSTANTS.unauthenticatedError, 0)
                break
            }
            break
          case 404:
            this.helper.openSnackBar(CONSTANTS.ressourceMissingMessage, 0)
            break
          case 500:
            break
          default:
            break
        }
      }
      else {
        message = error.message
        stack = error.stack || ''

        if (!environment.production)
          this.helper.openSnackBar(error.message + '/// ' + error.stack, 6000)

        if (error.message.includes('fileError'))
          this.helper.openSnackBar(CONSTANTS.fileError, 0)
      }

      if (!environment.production)
        this.loggingService.logError(message, stack)
    }
  }

